import { memo, SyntheticEvent } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';

interface CheckBoxAutocompleteProps<T extends string> {
  label: string;
  value: T[];
  options: T[];
  onChange: (values: T[]) => void;
  required?: boolean;
}

const _CheckBoxAutocomplete = <T extends string>({
  label,
  value,
  options,
  onChange,
  required,
}: CheckBoxAutocompleteProps<T>) => {
  const handleChange = (_: SyntheticEvent, v: T[]) => {
    onChange(v);
  };

  return (
    <Autocomplete
      value={value}
      options={options}
      onChange={handleChange}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            <Checkbox checked={selected} />
            {option}
          </li>
        );
      }}
      renderInput={(params) => <TextField {...params} label={`${label} ${required && '*'}`} />}
      disableCloseOnSelect
      multiple
    />
  );
};

export const CheckBoxAutocomplete = memo(_CheckBoxAutocomplete) as typeof _CheckBoxAutocomplete;
